import {MoneyRange} from "./Types/MoneyRange";
import {InputAdornment, MenuItem, Select} from "@mui/material";
import React from "react";

export function MoneyItemSelect(props: { selectOptions: MoneyRange[], value: MoneyRange, onChange: (value: MoneyRange) => void }) {

    let selectedValue = props.selectOptions.findIndex((entry) => {
        return props.value && entry.from === props.value.from && entry.to === props.value.to;
    });

    return <Select variant={"standard"}  value={selectedValue != -1 ? selectedValue : ''}
                   onChange={e => props.onChange(props.selectOptions[Number(e.target.value)])}>
        {props.selectOptions.map((entry, index) => {
            return <MenuItem key={index} value={index}>{entry.label}</MenuItem>;
        })
        }
    </Select>
}